import { getRandomInt } from './number';

// Random uid, suitable for internal use (e.g. auto-generated element IDs)
export function getUid(context = 'UID') {
  const date = new Date().valueOf().toString(36);
  const rand = getRandomInt(0, 100000000).toString(36);
  return `${context}.${date}.${rand}`;
}



// WEBPACK FOOTER //
// ./src/app/utils/uid.js